'use client';

import React from 'react';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { PulseIconButton } from 'src/components/PulseUI';
import type {
  MatchedPlay,
  PlayItemWidget,
} from 'src/api/redux/profileConfiguration/types';
import { toProfileWidget } from 'src/components/Profiles/shared/widgetRenderer';
import { WidgetGrid } from 'src/components/Profiles/shared/widgets/WidgetGrid';
import { sortPlayWidgets } from './PlaysCard';

interface PlaysDetailPanelProps {
  play: MatchedPlay;
  onClose: () => void;
}

const PlaysDetailPanel: React.FC<PlaysDetailPanelProps> = ({
  play,
  onClose,
}) => {
  const widgets = sortPlayWidgets(play.widgets);

  return (
    <div
      className="absolute inset-0 z-10 flex flex-col bg-neutral-50 animate-slide-in-right"
      data-testid={`plays-detail-panel-${play.id}`}
      role="dialog"
      aria-label={`${play.label} widgets`}
    >
      <div className="flex items-center justify-between rounded-lg p-4 border-b border-neutral-200 bg-white">
        <h3 className="text-base font-bold text-neutral-800 truncate">
          {play.label}
        </h3>
        <PulseIconButton
          icon={faXmark}
          variant="plain"
          size="sm"
          onClick={onClose}
          aria-label="Close play details"
          data-testid="plays-detail-panel-close"
        />
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto p-4">
        <WidgetGrid
          widgets={widgets.map((pw) => toProfileWidget(pw as unknown as PlayItemWidget))}
          columns={1}
          variant="default"
          parentLabel={play.label}
          testIdPrefix="plays-detail-widget"
        />
      </div>
    </div>
  );
};

export default PlaysDetailPanel;
